import React from "react";

import { classnames } from "@culturehq/components";
import SubtitleOption from "./SubtitleOption";

interface LanguageSelectorProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  changingLanguage: boolean;
  onLanguageChange: (language: string) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  availableLanguages, activeLanguageCode, changingLanguage, onLanguageChange
}) => (
  <div className={classnames("subtitle-accordian", "nav-tabs")}>
    {availableLanguages.map((language, index) => (
      <SubtitleOption
        activeLanguageCode={activeLanguageCode}
        changingLanguage={changingLanguage}
        key={index}
        language={language}
        onChangeLanguage={onLanguageChange}
      />
    ))}
  </div>
);

export default LanguageSelector;
